module.exports = __webpack_public_path__ + "img/hk-2013-3.0e10ea8d.jpg";